import React from "react";
import PlayCockpit from "./PlayCockpit";
import "./PlayCockpitDemo.scss";

/**
 * Demo wrapper for the Gaming Cockpit
 * Shows different states and configurations
 */
const PlayCockpitDemo: React.FC = () => {
    return (
        <div className="cockpit-demo">
            {/* Full Cockpit Experience */}
            <PlayCockpit />

            {/* Demo Controls Overlay */}
            <div className="demo-controls">
                <h3>🎮 DevourPlay Gaming Cockpit</h3>
                <p>Experience the future of gaming dashboards</p>

                <div className="demo-features">
                    <div className="feature">
                        <span className="feature__icon">🌟</span>
                        <span className="feature__text">Glass Morphism UI</span>
                    </div>
                    <div className="feature">
                        <span className="feature__icon">⚡</span>
                        <span className="feature__text">Real-time Updates</span>
                    </div>
                    <div className="feature">
                        <span className="feature__icon">🎯</span>
                        <span className="feature__text">Mission-Focused</span>
                    </div>
                    <div className="feature">
                        <span className="feature__icon">👥</span>
                        <span className="feature__text">Squad Integration</span>
                    </div>
                </div>

                <div className="demo-actions">
                    <button className="demo-button" onClick={() => window.location.reload()}>
                        Restart Boot Sequence
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PlayCockpitDemo;